/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Downgrade_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to request downgrade." |
*
* @param {Plan_Tab_Downgrade_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_error = /** @type {((inputs?: Plan_Tab_Downgrade_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade-Anfrage fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Failed to request downgrade.")
});